// extracted by mini-css-extract-plugin
export default {"paymentSection":"p8-z"};